export default {
  TODOS: 0,
  CLIENTE_INTERNO: 1,
  CLIENTE_EXTERNO: 2,
  PLATAFORMA: 3,
  
  tipoSolicitacaoList: function() {
    return [
      {
        id: 0,
        descricao: 'Todos'
      },
      {
        id: 1,
        descricao: 'Interna'
      },
      {
        id: 2,
        descricao: 'Externa'
      },
      {
        id: 3,
        descricao: 'Plataforma'
      }
    ]
  },
  getTipoSolicitacaoPorId: function(idTipoSolicitacao) {
    let tipoSolicitacaoRetorno = this.tipoSolicitacaoList()[0];
    this.tipoSolicitacaoList().forEach(tipoSolicitacao => {
      if (tipoSolicitacao.id == idTipoSolicitacao) {
        tipoSolicitacaoRetorno = tipoSolicitacao;
      }
    })
    return tipoSolicitacaoRetorno;
  }
}


// WEBPACK FOOTER //
// ./src/helpers/tipo-solicitacao.js